import React, { useState } from "react";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getClientid,
  getRoleList,
  getUserRole,
  getMenuList,
} from "redux/selectors";
import styled from "@emotion/styled";
import CheckInCheckout from "molecules/CheckInCheckout";
import UserMonthlyReport from "molecules/UserMonthlyReport";
import UserCheckinReport from "molecules/UserCheckinReport";
import NonStaffDashboard from "molecules/NonStaffDashboard";
import UserLeaveReport from "molecules/UserLeaveReport";
import DashboardMatrix from "./DashboardComponents/DashboardMatrix";
import TimesheetData from "./DashboardComponents/TimesheetData";
import Logs from "./DashboardComponents/Logs";
import EngagementCalendar from "./DashboardComponents/EngagementCalendar";
import RecentJoiners from "./DashboardComponents/RecentJoiners";
import MyCV from "./DashboardComponents/MyCV";
import DocumentTableView from "./DocumentFolders/DocumentTableView";
import AnnouncementList from "./DashboardComponents/AnnouncementList";
import BirthdaySpotLight from "./DashboardComponents/BirthdaySpotLight";
import { Col, Row } from "antd";
import dayjs from "dayjs";
import moment from "moment";

import MyNotifications from "./DashboardComponents/MyNotifications";
import usePendingCounts from "./DashboardComponents/usePendingCounts";


const StyledChartContainer = styled.div`
  // background: red;
  height: 100%;
  padding: 15px;
  box-shadow: 0px 4px 30px 0px #0000001f;
  border-radius: 8px;
`;
const GridContainer = styled.div`
  display: grid;
  /* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */
  /* grid-template-columns: repeat(2, 1fr); */
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  padding-top: 5px;
  grid-template-areas:
    "check-in-monthly user-checkin-report"
    "user-leave-report user-leave-report"; // Assign areas

  @media (max-width: 1024px) {
    // Adjust for medium screens
    grid-template-columns: repeat(auto-fill, 1fr);
    grid-template-areas:
      "check-in-monthly"
      "user-checkin-report"
      "user-leave-report";
  }
`;

const GridItem = styled.div`
  min-height: 200px;
  display: flex;
  flex-direction: column;
  &.check-in-monthly {
    grid-area: check-in-monthly;
  }
  &.user-checkin-report {
    grid-area: user-checkin-report;
  }
  &.user-leave-report {
    grid-area: user-leave-report;
  }
`;

const MyDashboard = ({ userRoleId, ClientId }) => {
  const [selectMonthYear, setSelectMonthYear] = useState({
    month: dayjs().format("MMMM"),
    year: dayjs().year(),
  });
  const [engagementsData, setEngagementsData] = useState("");
  const { pendingCounts, lastUpdated, isLoading: notificationsLoading } = usePendingCounts();
  const format =
    selectMonthYear.year && selectMonthYear.month
      ? "MMMM YYYY"
      : selectMonthYear.year
        ? "YYYY"
        : selectMonthYear.month
          ? "MMMM"
          : null;

  const formattedDate = format
    ? moment(
      `${selectMonthYear.month} ${selectMonthYear.year}`,
      "MMMM YYYY"
    ).format(format)
    : "";
  return (
    <>
      <MyDashboardWrap>
        <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
          <Col xs={24} sm={24} md={24} lg={17}>
            <StyledChartContainer>
              <EngagementCalendar
                selectMonthYear={selectMonthYear}
                setSelectMonthYear={setSelectMonthYear}
                engagementsData={engagementsData}
                setEngagementsData={setEngagementsData}
              />
            </StyledChartContainer>
          </Col>
          <Col xs={24} sm={24} md={24} lg={7}>
            <MyNotifications pendingCounts={pendingCounts} lastUpdated={lastUpdated} isLoading={notificationsLoading} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            {/* <StyledChartContainer> */}
            <Logs />
            {/* </StyledChartContainer> */}
          </Col>
        </Row>
        <GridContainer>

          <GridItem className="check-in-monthly">
            <StyledChartContainer>
              <TimesheetData />
            </StyledChartContainer>
          </GridItem>
          <GridItem className="user-checkin-report">
            <StyledChartContainer>
              <AnnouncementList />
            </StyledChartContainer>
          </GridItem>

        </GridContainer>
        <GridContainer>

          <GridItem className="check-in-monthly">
            <StyledChartContainer>
              <RecentJoiners />
            </StyledChartContainer>
          </GridItem>
          <GridItem className="user-checkin-report">
            <StyledChartContainer>
              <BirthdaySpotLight />
            </StyledChartContainer>
          </GridItem>

        </GridContainer>
        <GridContainer>
          <GridItem className="check-in-monthly">
            <StyledChartContainer>
              <DashboardMatrix />
            </StyledChartContainer>
          </GridItem>
          <GridItem className="user-checkin-report">
            <StyledChartContainer>
              <MyCV />
            </StyledChartContainer>
          </GridItem>

        </GridContainer>

        <GridContainer>

          <GridItem className="check-in-monthly">
            <UserMonthlyReport />
          </GridItem>
          <GridItem className="user-checkin-report">
            <UserCheckinReport />
          </GridItem>
          <GridItem className="user-leave-report">
            <UserLeaveReport />
          </GridItem>
        </GridContainer>
        {userRoleId == 1 && <NonStaffDashboard />}
      </MyDashboardWrap>
    </>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  ClientId: getClientid(state),
  roleList: getRoleList(state),
  userRoleType: getUserRole(state),
  menuList: getMenuList(state),
});

export default connect(mapStateToProps, null)(MyDashboard);

const MyDashboardWrap = styled.div``;
